import styled from 'styled-components';

export default styled.button`
  display: block;
  width: 100%;
  text-align: left;
  cursor: pointer;
  height: 70px;
  border: none;
  padding: 0 30px;
  color: #32383e;
  font-size: 16px;
  background: transparent;

  &:hover {
    background: transparent;
  }
`;

